'use strict';

class RcmFatAlgolia {
    constructor(fat) {
        this.fat = fat;

        // Algolia parameters
        this.appId = 'TK2MYWX8R4';
        this.appKey = '8068134b13ed780a7d3f02c0769f7875';
        //this.indexName = this.fat._helperGetDrupalEnv() == 'dev' ? 'find-a-teacher-v3-dev' : 'find-a-teacher-v3';
        this.indexName = (typeof TPS === 'undefined' || typeof TPS.RcmNTDIndexName === 'undefined' || TPS.RcmNTDIndexName === '') ? 'find-a-teacher-v3' : TPS.RcmNTDIndexName;
        this.hitsPerPage = 1000;
        this.page = 0;

        // Algolia objects
        this.client = algoliasearch(this.appId, this.appKey);
        this.index = this.client.initIndex(this.indexName);
    }

    getBaseSettings() {
        return {
            page: this.page,
            hitsPerPage: this.hitsPerPage,
            facets: this.fat.facetNames,
            facetFilters: [],
            sortFacetValuesBy: 'alpha',
            maxValuesPerFacet: 500,
        };
    }

    // Populate facets
    populateFacets() {
        // Facet fields
        if (this.fat.form.facetFields.length > 0) {
            this.populateFacetInputs();
        }
    }

    // Populate facet inputs
    populateFacetInputs() {
        this.algoliaAwaitingCounter = 0;

        var self = this;

        // Facets
        $(this.fat.form.facetFields).each(function () {
            var field = $(this);
            var facetName = field.data('facet');
            var defaultValue = field.data('defaultValue') || false;

            self.algoliaAwaitingCounter++;
            self.populateFacetInput(self, field, facetName, defaultValue);
        });
    }

    // Populate facet
    populateFacetInput(self, field, facetName, defaultValue) {
        if (defaultValue) {
            $('<option />').val('').text(defaultValue).appendTo(field);
        }

        self.index.searchForFacetValues({
            facetName: facetName,
            facetQuery: '',
            maxFacetHits: 100,
            sortFacetValuesBy: 'alpha'
        }, function (err, content) {
            if (err) {
                console.error(err);
                return;
            }

            self.algoliaAwaitingCounter--;

            $(content.facetHits).each(function (i, v) {
                $('<option />').val(v.value).text(v.value).appendTo(field);
            });

            if (0 == self.algoliaAwaitingCounter) {
                self.fat.callbacks.onReady();
            }
        });
    }

    // Do search (from query string parameters)
    doSearchFromQueryString() {
        var self = this;
        var doSearch = true;

        // First page
        this.page = 0;

        // Search settings
        this.searchSettings = this.getBaseSettings();

        // All parameters non-geo
        $(this.fat.facetNames).each(function (index, value) {
            var qs = self.fat._helperGetUrlParameterByName(value);

            if (qs) {
                qs = qs.split(',');

                $(qs).each(function (index2, value2) {
                    var facetToPush = value + ':' + value2;

                    if (self.searchSettings.facetFilters.indexOf(facetToPush) == -1) {
                        self.searchSettings.facetFilters.push(facetToPush);
                    }
                });
            } else {
                if (value == 'disciplines') {
                    doSearch = false;
                }
            }
        });

        // If there is a name
        var queryText = '';
        var teacherName = self.fat._helperGetUrlParameterByName('fullName');

        if (teacherName) {
            self.searchSettings['restrictSearchableAttributes'] = ['fullName'];
            queryText = teacherName;
        } else {
            delete self.searchSettings.restrictSearchableAttributes;
        }
        
        // Geo field
        var qsPlace = this.fat._helperGetUrlParameterByName('place');

        if (qsPlace) {
            // Get latitude and longitude from place ID
            this.fat.google.prePopulateAutocomplete(qsPlace, function () {
                var lat = self.fat.form.geoField.data('geoLat');
                var lng = self.fat.form.geoField.data('geoLng');

                self.searchSettings.aroundLatLng = lat + ', ' + lng;
                self.searchSettings.getRankingInfo = true;

                // Do the search
                self.index.search(queryText, self.searchSettings, function (err, content) {
                    if (err) {
                        console.error(err);
                        return;
                    }

                    // Search results
                    self.fat.callbacks.onResults(content, false);

                    // Profile
                    var objectID = self.fat._helperGetUrlParameterByName('id');
                    var uniqueId = self.fat._helperGetUrlParameterByName('uid');

                    if (objectID && uniqueId) {
                        var obj = self.fat.resultsList.getItemObj(uniqueId);

                        // Probably the profile came from a different search results page (2, 3, ...), so let's fetch the profile individually
                        if (obj.length == 0) {
                            self.searchSettings.facetFilters.push('objectID:' + objectID);

                            // Do the search
                            self.index.search(queryText, self.searchSettings, function (err2, content2) {
                                if (err2) {
                                    console.error(err2);
                                    return;
                                }

                                // Remove the objectID from the search settings to avoid conflict with browser history update
                                self.searchSettings.facetFilters.pop(); // objectID

                                // Ok, I get it!
                                if (content2.hits.length == 1) {
                                    var data = content2.hits[0];
                                    var lat = data._rankingInfo.matchedGeoLocation.lat;
                                    var lon = data._rankingInfo.matchedGeoLocation.lng;
                                    self.fat.profile.show(uniqueId, lat, lon, true, data);
                                // Oops, why are you trying to load a profile that doesn't came from this search?
                                } else {
                                    aler('Profile not found');
                                }
                            });
                        // Ok, I found it on the first page!
                        } else {
                            var lat = obj.data('lat');
                            var lon = obj.data('lon');
                            self.fat.profile.show(uniqueId, lat, lon);
                        }
                    }
                });
            });
        } else {
            doSearch = false;
        }

        return doSearch;
    }

    // Do search (from user interaction - next page)
    doSearchNextPage() {
        this.page++;
        this.doSearchFromUserInteraction(false, false, false); // isFacetFilter = false, isMobile = false, isFormSubmit = false
    }

    // Do search (from user interaction - form submit)
    doSearchFromSubmit() {
        this.page = 0;
        this.doSearchFromUserInteraction(false, false, true); // isFacetFilter = false, isMobile = false
    }

    // Do search (from user interaction - filtered)
    doSearchFiltered(isFacetFilter, isMobile) {
        this.page = 0;
        this.doSearchFromUserInteraction(isFacetFilter, isMobile, false); // isFormSubmit = false
    }

    doSearchMapMove() {
        this.page = 0;
        this.doSearchFromUserInteraction(false, false, false, true);
    }

    // Do search (from user interaction)
    doSearchFromUserInteraction(isFacetFilter, isMobile, isFormSubmit, isMapMove = false) {
        isMobile = isMobile ? true : false;

        var self = this;

        // Is facet filter on desktop?
        var isFacetFilterOnDesktop = isFacetFilter && !isMobile;

        // Search settings
        this.searchSettings = this.getBaseSettings();

        // Set English as default
        if (isFormSubmit) {
            this.searchSettings.facetFilters.push('languages:English');
        }

        // Facet fields
        this.fat.form.facetFields.each(function () {
            var field = $(this);
            var facetName = field.data('facet');
            var facetValue = $.trim(field.val());
            var facetToPush = facetName + ':' + facetValue;

            if (facetValue != '') {
                if (self.searchSettings.facetFilters.indexOf(facetToPush) == -1) {
                    self.searchSettings.facetFilters.push(facetToPush);
                }
            }
        });

        // Facet tags (that are no inputs)
        $(this.fat.resultsFilters.facetTagsSelector).filter('.active').filter(function () {
            return isMobile ? $(this).closest('#fatv2-off-canvas').length > 0 : $(this).closest('.fatv2-results-filters').length > 0;
        }).each(function () {
            var field = $(this).children('a');
            var facetName = field.data('facet');
            var facetValue = field.data('facetValue');
            var facetToPush = facetName + ':' + facetValue;

            if (facetValue != '') {
                if (self.searchSettings.facetFilters.indexOf(facetToPush) == -1) {
                    self.searchSettings.facetFilters.push(facetToPush);
                }
            }
        });

        // Geo field
        var lat = this.fat.form.geoField.data('geoLat');
        var lng = this.fat.form.geoField.data('geoLng');

        if (isMapMove) {
            var mapCenter = self.fat.resultsMap.gMap.getCenter();
            lat = mapCenter.lat();
            lng = mapCenter.lng();
        }

        this.searchSettings.aroundLatLng = lat + ', ' + lng;
        this.searchSettings.getRankingInfo = true;

        var placeID = this.fat.form.geoPlaceField.val();
        if (placeID) {
            this.fat.google.prePopulateAutocomplete(placeID, null);
        }

        var queryText = '';

        // If there is a name
        if ($(this.fat.resultsFilters.nameFieldSelector).val() !== '') {
            this.searchSettings['restrictSearchableAttributes'] = ['fullName'];
            queryText = $(this.fat.resultsFilters.nameFieldSelector).val();
        } else {
            delete this.searchSettings.restrictSearchableAttributes;
        }

        // Do the search
        this.index.search(queryText, this.searchSettings, function (err, content) {
            if (err) {
                console.error(err);
                return;
            }

            if (isMapMove) {
                self.fat.callbacks.onResults(content, isFacetFilterOnDesktop, true);
            } else {
                self.fat.callbacks.onResults(content, isFacetFilterOnDesktop);
            }
        });
    }

    // Is the facet selected
    isFacetSelected(facetName, facetValue) {
        return this.searchSettings.facetFilters.indexOf(facetName + ':' + facetValue) > -1;
    }
}
